import { useState, useCallback } from "react";
import withDocumentTitle from "../withDocumentTitle";
import SearchForm from "./SearchForm";
import ManualReturnsTable from "./ManualReturnsTable";
import { useQueryClientInvalidation } from "./manualReturns.utils";

function ManualReturns() {
  const [searchManualReturns, setSearchManualReturns] = useState();

  const invalidateQueries = useQueryClientInvalidation();

  const handleSearch = useCallback(
    (search) => {
      setSearchManualReturns(search);

      invalidateQueries(search);
    },
    [invalidateQueries]
  );

  return (
    <div className="tw-space-y-4 tw-px-3 md:tw-px-3">
      <div className="tw-mb-10">
        <SearchForm handleSearch={handleSearch} />
      </div>

      <ManualReturnsTable searchManualReturns={searchManualReturns} />
    </div>
  );
}

export default withDocumentTitle(ManualReturns, {
  pageTitle: "Manual Returns",
});
